"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _SNETTextareaModule = _interopRequireDefault(require("./SNETTextarea.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SNETTextarea = _ref => {
  let {
    label,
    rowCount,
    colCount,
    name,
    value,
    onChange,
    content,
    minCount,
    maxCount,
    showInfoIcon,
    infoMsg,
    extraInfo,
    disabled,
    readOnly = false,
    error
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETTextareaModule.default.textareaIconContainer
  }, showInfoIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETTextareaModule.default.iconTooltipContainer
  }, /*#__PURE__*/_react.default.createElement(_Info.default, null), /*#__PURE__*/_react.default.createElement("p", null, infoMsg)) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: _SNETTextareaModule.default.textareaContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _SNETTextareaModule.default.label
  }, label), /*#__PURE__*/_react.default.createElement("textarea", {
    rows: rowCount,
    cols: colCount,
    name: name,
    value: value,
    onChange: onChange,
    disabled: disabled,
    className: error ? _SNETTextareaModule.default.error : "",
    maxLength: maxCount,
    readOnly: readOnly
  }, content), maxCount ? /*#__PURE__*/_react.default.createElement("span", {
    className: _SNETTextareaModule.default.charLength
  }, minCount, "/", maxCount, " char") : null, extraInfo ? /*#__PURE__*/_react.default.createElement("span", {
    className: _SNETTextareaModule.default.extraInfo
  }, extraInfo) : null));
};
SNETTextarea.propTypes = {
  label: _propTypes.default.string,
  rowCount: _propTypes.default.number,
  colCount: _propTypes.default.number,
  name: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  content: _propTypes.default.string,
  minCount: _propTypes.default.number,
  maxCount: _propTypes.default.number
};
var _default = exports.default = SNETTextarea;